/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
//components
//constants
//style
import './Billingpage.scss'
import {useDispatch, useSelector} from 'react-redux'
import ToggleSwitch from 'react-bootstrap/Form'
import moment from 'moment'
import ReactPaginate from 'react-paginate'
import {useDebounce, KTSVG} from '../../../../../_metronic/helpers'
import {isLoading, startLoadding} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
// import { GetPurchaseHistory } from './BillingSlice/BillingSlice'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import NodataYet from '../../../../Components/NodataYet'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {useLocation} from 'react-router-dom'
import {ACCOUNT_TYPE, STRIPE_PAYMENT_STATUS} from '../../../../Utils/Constant/ConstantForWebsite'
import clsx from 'clsx'
import {
  useUpdateAccountTypeRequestMutation,
  useUpdateBillingAddresMutation,
} from '../../../../../services/cellcast'
import {toast} from 'react-toastify'
import {fetchAsyncUserDetails, getIsOwner} from '../Overview/OverviewSlice/UserDetailsSlice'
import {isEmpty, toUpper} from 'lodash'
import {usePurchaseHistory} from './useBilling'
import {Field, Form, Formik} from 'formik'
import {BillingAddressSchema} from '../../../../Utils/_helpers/ValidationSchema'
import BillingSubscription from './BillingSubscription'
import BillingOverview from './BillingOverview'

const BillingTable = () => {
  const dispatch = useDispatch()
  const {fetchPurchaseHistory, purchaseHistory} = usePurchaseHistory()
  const [updateBillingAddress] = useUpdateBillingAddresMutation()

  const generalLoading = useSelector(isLoading)
  const location = useLocation()
  const ref = useRef<HTMLDivElement | null>(null)
  const [isChecked, setIsChecked] = useState<boolean>(false)

  // const purchase_history = useSelector((state: any) => state?.paymentGateway?.userPurchase)
  const userId = GeneralDataOFLoginUser()?.user?._id
  const generalUserData = useSelector((state: any) => state?.userDetails?.userDetails?.data?.user)
  const isOwner = useSelector(getIsOwner)
  const userData = useSelector((state: any) => state?.userDetails?.userDetails?.data)

  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
    duration: 'all',
  })
  const debouncedSearchTerm = useDebounce(page?.search, 3000)
  useEffect(() => {
    dispatch(startLoadding())
    AuthenticateUser('see-credit-history') && fetchPurchaseHistory({page, id: userId})
  }, [debouncedSearchTerm, page.page, page.size, page.duration])

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const scrollId = queryParams.get('scrollId')
    if (scrollId && scrollId === 'purchase-history' && ref.current != null) {
      const timeout = setTimeout(() => {
        if (ref.current) {
          ref.current.scrollIntoView({behavior: 'smooth'})
        }
      }, 500)
      return () => clearTimeout(timeout)
    }
  }, [location.search, generalLoading])

  const [updateAcctountType, {isLoading: isLoadingUpdateAccountType}] =
    useUpdateAccountTypeRequestMutation()

  const handleChangeAccountType = async (isPostPaid: boolean) => {
    const accountType = isPostPaid ? ACCOUNT_TYPE.POSTPAID : ACCOUNT_TYPE.PREPRAID
    setIsChecked(isPostPaid)
    updateAcctountType({
      accountType,
    })
      .unwrap()
      .then((e) => {
        toast.success(e?.message)
      })
      .catch((e) => toast.error(e?.data?.message))
  }

  useEffect(() => {
    setIsChecked(generalUserData?.accountType === 'postpaid')
  }, [generalUserData])

  return (
    <>
      <div className='card mb-10'>
        <div className='card-header border-0 pt-1 ps-5 ms-3'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>Billing details</span>
          </h3>
        </div>
        <div className='card-body border-top p-9'>
          <div className='row'>
            <div className='col-lg-6'>
              <h4>Active since {moment(generalUserData?.createdAt).format('MMM DD, YYYY')}</h4>
              <span className='text-muted'>This is the date you joined Cellcast</span>
            </div>
            <div className='col-lg-6'>
              <h4>{generalUserData?.accountType}</h4>
              <span className='text-muted'>Billing account type.</span>
              <div></div>
              <span className='text-muted'>Toggle Button to request account type change</span>
              <div className='d-flex gap-2'>
                <h5
                  className={clsx({
                    'text-primary': generalUserData?.accountType === ACCOUNT_TYPE.PREPRAID,
                  })}
                >
                  Prepaid
                </h5>
                <ToggleSwitch.Check
                  onChange={(e) => {
                    const isPostPaid = e.target.checked
                    handleChangeAccountType(isPostPaid)
                  }}
                  type='switch'
                  id='custom-switch'
                  checked={isChecked}
                  disabled
                />
                <h5
                  className={clsx({
                    'text-primary': generalUserData?.accountType === ACCOUNT_TYPE.POSTPAID,
                  })}
                >
                  Postpaid
                </h5>
              </div>
            </div>
          </div>

          <hr className='border border-1 opacity-50' />
          <div className='row mt-5'>
            <Formik
              initialValues={{
                billingEmail:
                  userData?.parent?.email ||
                  userData?.user?.billingEmail ||
                  userData?.user?.email ||
                  '',
                billingPhoneNumber:
                  userData?.parent?.mobile ||
                  userData?.user?.billingPhoneNumber ||
                  userData?.user?.mobile ||
                  '',
              }}
              validationSchema={BillingAddressSchema}
              onSubmit={async (values) => {
                try {
                  const result = await updateBillingAddress(values).unwrap()
                  const isError = !isEmpty(result?.error)
                  dispatch(fetchAsyncUserDetails())

                  toast[isError ? 'error' : 'success'](result?.message)
                } catch (err) {
                  toast.error('Something went wrong')
                }
              }}
              enableReinitialize
            >
              {({values, handleChange, handleSubmit, touched, errors, isSubmitting}) => (
                <Form>
                  <div className='row align-items-center mb-5'>
                    <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                      <h5 className='title-h5 required'>Billing Email</h5>
                    </div>
                    <div className='col-xl-8 col-lg-6 col-md-6 col-sm-12 col-12'>
                      <Field
                        className='form-control bg-light border-0'
                        type='text'
                        name='billingEmail'
                        disabled={!isOwner}
                      />
                      {touched.billingEmail && errors.billingEmail && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert' className='text-danger'>
                              {errors.billingEmail}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='row align-items-center mb-5'>
                    <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                      <h5 className='title-h5 required'>Billing Phone Number</h5>
                    </div>
                    <div className='col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12'>
                      <Field
                        className='form-control bg-light border-0'
                        type='text'
                        name='billingPhoneNumber'
                        disabled={!isOwner}
                      />
                      {touched.billingPhoneNumber && errors.billingPhoneNumber && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert' className='text-danger'>
                              {errors.billingPhoneNumber}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {isOwner && (
                    <div className='card-footer d-flex justify-content-end py-6 px-9'>
                      <button
                        type='submit'
                        className='btn btn-md btn-primary me-3'
                        disabled={isSubmitting}
                      >
                        <span className='indicator-label'>
                          {isSubmitting ? 'Saving...' : 'Save Change'}
                        </span>
                      </button>
                    </div>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>

      {/* New Billing Overview Section */}
      <BillingOverview />
      <div className={`card purchase-table `} ref={ref}>
        <div className='card-header border-0 pt-5 ps-5 ms-3'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>Credit Purchase History</span>
          </h3>
          <div className='card-toolbar'>
            <div className='nav-item pe-8 mb-1'>
              <form
                data-kt-search-element='form'
                className='w-100 position-relative'
                autoComplete='off'
              >
                <KTSVG
                  path='/media/icons/duotune/general/gen021.svg'
                  className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 translate-middle-y ms-2'
                />

                <input
                  type='text'
                  className='form-control form-control-flush ps-10 rounded border-gray-200 border'
                  name='search'
                  onChange={(e: any) => {
                    setPage({...page, search: e.target.value})
                  }}
                  placeholder='Search...'
                  data-kt-search-element='input'
                />
              </form>
            </div>
            <ul className='nav nav-stretch  nav-line-tabs border-transparent'>
              <li className='nav-item'>
                <a
                  className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                    page.duration === 'month' && 'active'
                  }`}
                  data-bs-toggle='tab'
                  onClick={() => setPage({...page, duration: 'month'})}
                >
                  Months
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                    page.duration === 'week' && 'active'
                  }`}
                  data-bs-toggle='tab'
                  onClick={() => setPage({...page, duration: 'week'})}
                >
                  Week
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                    page.duration === 'day' && 'active'
                  }`}
                  data-bs-toggle='tab'
                  onClick={() => setPage({...page, duration: 'day'})}
                >
                  Day
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                    page.duration === 'all' && 'active'
                  }`}
                  data-bs-toggle='tab'
                  onClick={() => setPage({...page, duration: 'all'})}
                >
                  ALL
                </a>
              </li>
            </ul>
          </div>
        </div>
        {purchaseHistory?.items?.length > 0 ? (
          <div className='card-body p-0 mt-5'>
            <div className='table-responsive'>
              <table className='table align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bolder text-muted bg-light text-bolder table-row-gray-200'>
                    <th className='ps-4 min-w-125px rounded-start fw-bolder'>Created</th>
                    <th className='min-w-125px fw-bolder'>Paid On</th>
                    <th className='min-w-100px fw-bolder'>Invoice Id</th>
                    <th className='min-w-100px fw-bolder'>Type</th>
                    <th className='min-w-100px fw-bolder'>Total MMS</th>
                    <th className='min-w-100px fw-bolder'>Total SMS</th>
                    <th className='min-w-100px fw-bolder'>Total + GST</th>
                    <th className='min-w-70px fw-bolder'>Status</th>
                    <th className='min-w-150px  rounded-end fw-bolder text-end pe-10 text-center'>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className='p-5'>
                  {purchaseHistory?.items?.map((data: any, idx: number) => {
                    const badgeClass = clsx('badge', {
                      'badge-light-success': data?.status === 'paid',
                      'badge-light-danger': ['open', 'draft'].includes(data?.status),
                    })

                    return (
                      <tr key={idx}>
                        <td className='ps-3 table-row-gray-200 border-bottom border-top ps-5'>
                          <a
                            //   href='#'
                            className='d-block mb-1 fs-6'
                          >
                            {data?.createdAt
                              ? moment(data?.createdAt).format('MMM DD YYYY')
                              : ''}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className='d-block mb-1 fs-6'
                          >
                            {data?.status === 'paid' && data?.purchasedDate
                              ? moment(data?.purchasedDate).format('MMM DD YYYY')
                              : ''}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className='d-block mb-1 fs-6'
                          >
                            {data?.invoice}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className={
                              data?.type === 'SMS'
                                ? 'badge badge-light-info'
                                : 'badge badge-light-success'
                            }
                          >
                            {data?.type?.toUpperCase()}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className='d-block mb-1 fs-6'
                          >
                            {data?.type === 'mms' && data?.allowedMessages}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className='d-block mb-1 fs-6'
                          >
                            {data?.type === 'sms' && data?.allowedMessages}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className='d-block mb-1 fs-6'
                          >
                            ${data?.amount.toFixed(2)}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a className={badgeClass}>
                            {toUpper(data?.status === 'open' ? 'unpaid' : data?.status)}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-top text-end pe-5 text-center'>
                          {[STRIPE_PAYMENT_STATUS.PAID].includes(data?.status) ? (
                            <button
                              onClick={() => window.open(`${data.invoicePdf}`, '_self')}
                              className='btn btn-sm btn-light btn-active-light-primary me-3 fw-500'
                            >
                              Download
                            </button>
                          ) : (
                            <button
                              onClick={() => window.open(`${data.invoiceUrl}`, '_self')}
                              className='btn btn-sm btn-light btn-active-light-primary me-3 fw-500'
                            >
                              Pay Now
                            </button>
                          )}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <NodataYet message={'No invoice yet'} />
        )}

        <div className='d-flex justify-content-end'>
          <div className='abcd px-6'>
            <ReactPaginate
              previousLabel='<'
              nextLabel='>'
              pageCount={purchaseHistory?.totalPages}
              onPageChange={(e) => setPage({...page, page: e.selected + 1})}
              containerClassName={'pagiantion'}
              previousLinkClassName={'pagination__link'}
              nextLinkClassName={'pagination__link'}
              disabledClassName={'pagination__link--disabled'}
              activeClassName={'pagination__link--active'}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export {BillingTable}
